/* Lunette — the slide-in cart carries the offers.
   Shoppers open the cart from the bag icon or right after "Add to cart", read what is in it and
   press Checkout; almost nobody visits /cart. So the rows that sit on the cart page — shipping
   line, second-cup offer, add-ons, trust — are rendered here too, inside the theme's slide-in
   cart, under the line items and above the pinned Checkout. The HTML comes from the cart page's
   own sections through Shopify's section rendering, so both places always say the same thing.

   The section ids carry the cart template's id (template--NNN__lun_cart_tiers), which differs per
   theme: read once from the cart page, cached for the session. The theme re-renders the slide-in
   after every change (quantity, remove, add) and drops foreign nodes: an observer puts ours back
   and fetches fresh copies. Our own Add buttons announce `cart:refresh`; this file answers it by
   telling the theme (`cart:update`, so the bag count and the slide-in update themselves) instead
   of reloading the page. Installed from layout/theme.liquid; inert without a slide-in cart. */
(function () {
  if (window.__lunDrawerRowsBound) return;
  window.__lunDrawerRowsBound = true;

  var KEYS = ['lun_cart_shipping', 'lun_cart_tiers', 'lun_cart_upsell', 'lun_cart_trust'];
  var SUFFIX = '--drawer';        // our copies get their own ids: no clash with the cart page's originals
  var REFRESH_DELAY = 150;        // ms; collapses the burst of mutations one re-render causes
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cacheKey = 'lun_cart_rows_ids:' + ((window.Shopify && window.Shopify.theme && window.Shopify.theme.id) || 'theme');
  var ids = null;                 // ['template--NNN__lun_cart_shipping', …] in KEYS order
  /* The theme's morph treats two nodes as the same whenever the tag matches (an id only counts when
     both sides have one), then rewrites the old node in place — a plain <div> of ours became its
     .cart__ctas. A tag the theme never emits can only be dropped, never rewritten. */
  /* 27 Oct: three boxes, same order as the cart page — proof + free shipping on top of the items, the offers and
     reviews under them, USPs + payment methods under the pinned Checkout. Each box holds KEYS by index. */
  var BOXES = [
    { tag: 'lun-drawer-top', keys: [0], where: function () { return slot(); }, first: true },
    { tag: 'lun-drawer-rows', keys: [1, 2], where: function () { return slot(); }, first: false },
    { tag: 'lun-drawer-foot', keys: [3], where: function () { var d = drawer(); return d ? d.querySelector('.cart-drawer__summary') : null; }, first: false }
  ];
  var BOX_TAG = 'lun-drawer-rows';
  var box = null;
  var nodes = {};                 // tag -> our element
  var timer = null;
  var pending = null;

  function drawer() { return document.querySelector('cart-drawer-component'); }
  function slot() { var d = drawer(); return d ? d.querySelector('.cart-drawer__items') : null; }
  function isOpen() { var d = drawer(); var dlg = d && d.querySelector('dialog'); return !!(dlg && dlg.open); }

  /* Our container — rebuilt if the theme ever touched it (a hijacked node keeps the reference but not the attributes). */
  function ensureBox(tag) {
    tag = tag || BOX_TAG;
    var el = nodes[tag];
    if (!el || el.tagName.toLowerCase() !== tag || el.id !== tag || !el.hasAttribute('data-lun-drawer-rows')) {
      el = document.createElement(tag);
      el.id = tag;
      el.className = tag;
      el.setAttribute('data-lun-drawer-rows', '');
      nodes[tag] = el;
    }
    if (tag === BOX_TAG) box = el;
    if (!document.getElementById('lun-drawer-rows-style')) {
      var st = document.createElement('style'); st.id = 'lun-drawer-rows-style';
      st.textContent = 'lun-drawer-rows{display:block;padding-bottom:12px}lun-drawer-top{display:block;padding:4px 0 12px}lun-drawer-foot{display:block}';
      document.head.appendChild(st);
    }
    return el;
  }

  function isPlaced(b) {
    var el = nodes[b.tag], parent = b.where();
    if (!el || !parent || el.parentNode !== parent || el.id !== b.tag) return false;
    return b.first ? parent.firstElementChild === el : parent.lastElementChild === el;
  }

  function place() {
    var s = slot(); if (!s) return false;
    BOXES.forEach(function (b) {
      var parent = b.where(); if (!parent) return;
      var el = ensureBox(b.tag);
      if (isPlaced(b)) return;
      if (b.first) parent.insertBefore(el, parent.firstChild); else parent.appendChild(el);
    });
    return true;
  }

  /* The cart template's section ids, from the cart page, once per session. */
  function loadIds() {
    if (ids) return Promise.resolve(ids);
    if (pending) return pending;
    try { var c = sessionStorage.getItem(cacheKey); if (c) { ids = JSON.parse(c); return Promise.resolve(ids); } } catch (e) {}
    pending = fetch(root + 'cart', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var found = KEYS.map(function (k) {
          var m = html.match(new RegExp('id="shopify-section-(template--[0-9]+__' + k + ')"'));
          return m ? m[1] : null;
        });
        if (found.every(Boolean)) {
          ids = found;
          try { sessionStorage.setItem(cacheKey, JSON.stringify(ids)); } catch (e) {}
        }
        pending = null;
        return ids;
      })
      .catch(function () { pending = null; return null; });
    return pending;
  }

  function refresh() {
    loadIds().then(function (list) {
      if (!list) return;
      // plain request: an Accept: application/json header makes Shopify answer with cart.js instead
      return fetch(root + 'cart?sections=' + list.join(','), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data) return;
          var html = list.map(function (id) {
            var h = data[id];
            // our copy gets its own element id, in the markup and in the section's own <style>/<script>
            return typeof h === 'string' ? h.split('shopify-section-' + id).join('lun-drawer-' + id + SUFFIX) : '';
          });
          BOXES.forEach(function (b) {
            ensureBox(b.tag).innerHTML = b.keys.map(function (i) { return html[i]; }).join('');
          });
          place();  // in the document first, so the sections' own scripts run when re-created
          BOXES.forEach(function (b) {
            nodes[b.tag].querySelectorAll('script').forEach(function (old) {
              var n = document.createElement('script'); n.textContent = old.textContent; old.replaceWith(n);
            });
          });
        });
    }).catch(function () {});
  }
  function scheduleRefresh() { clearTimeout(timer); timer = setTimeout(refresh, REFRESH_DELAY); }

  /* Our Add buttons: add done → tell the theme, which re-renders the slide-in and the bag count. */
  function announce() {
    return fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'lunette-rows', data: { source: 'lunette-rows', itemCount: cart ? cart.item_count : 0 } }
        }));
        var d = drawer();
        if (d && typeof d.open === 'function' && !isOpen()) d.open();
        scheduleRefresh();
      });
  }

  function init() {
    var d = drawer(); if (!d) return;
    place();
    var section = d.closest('.shopify-section') || document.body;
    new MutationObserver(function () {
      var s = slot();
      if (s && BOXES.some(function (b) { return b.where() && !isPlaced(b); })) { place(); scheduleRefresh(); }
    }).observe(section, { childList: true, subtree: true });
    // opening the slide-in (bag icon or auto-open after add): make sure the rows are current
    new MutationObserver(function () { if (isOpen()) { place(); scheduleRefresh(); } })
      .observe(d, { attributes: true, attributeFilter: ['open'], subtree: true });
    document.addEventListener('cart:update', function (e) {
      var data = e && e.detail && e.detail.data;
      if (data && data.source === 'lunette-rows') return;  // that one already scheduled a refresh
      scheduleRefresh();
    });
    document.addEventListener('cart:refresh', function (e) {
      e.preventDefault();  // handled here: no page reload
      announce().catch(function () { window.location.reload(); });
    });
    // ids ready before the slide-in is first opened; the fetch is idle work
    var warm = function () { loadIds().then(function () { if (isOpen()) refresh(); }); };
    if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 4000 }); else setTimeout(warm, 1500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
